import { START_AUTHENTICATION } from '../constants/actionTypes';

const startAuthentication = () => ({
    type: START_AUTHENTICATION,
  });

export default startAuthentication;
